// extracted by mini-css-extract-plugin
module.exports = {"SelectableTag":"SelectableTag_SelectableTag__XM4P3","SelectableTag_selected":"SelectableTag_SelectableTag_selected__zXsNN"};